








import { Component, Vue } from "vue-property-decorator";
import RevisarReservaChapuzonKids2026 from "@/components/Reserva/RevisarReservaChapuzonKids2026.vue";

@Component({
  components: {
    RevisarReservaChapuzonKids2026
  }
})
export default class RevisarReservaChapuzonKids2026View extends Vue {}
